"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.string.link");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
var BookmarkCell = function BookmarkCell(_ref) {
    var _bookmark$metadata, _bookmark$metadata$ta, _bookmark$metadata2, _bookmark$metadata2$c, _bookmark$metadata3, _bookmark$metadata4, _bookmark$metadata5, _bookmark$metadata6;
    var bookmark = _ref.bookmark, removeBookmark = _ref.removeBookmark, viewType = _ref.viewType, sample = _ref.sample;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: viewType
    }, /*#__PURE__*/ react_1.default.createElement(Alignment, {
        href: bookmark.link
    }, /*#__PURE__*/ react_1.default.createElement(Content, null, /*#__PURE__*/ react_1.default.createElement(ImageWrapper, {
        className: viewType
    }, /*#__PURE__*/ react_1.default.createElement(StyledImage, {
        objectFit: "cover",
        src: bookmark.imageUrl
    })), /*#__PURE__*/ react_1.default.createElement(Caption, {
        className: viewType
    }, /*#__PURE__*/ react_1.default.createElement(Tags, null, (_bookmark$metadata = bookmark.metadata) === null || _bookmark$metadata === void 0 ? void 0 : (_bookmark$metadata$ta = _bookmark$metadata.tags) === null || _bookmark$metadata$ta === void 0 ? void 0 : _bookmark$metadata$ta.join(', '), (_bookmark$metadata2 = bookmark.metadata) === null || _bookmark$metadata2 === void 0 ? void 0 : (_bookmark$metadata2$c = _bookmark$metadata2.categories) === null || _bookmark$metadata2$c === void 0 ? void 0 : _bookmark$metadata2$c.join(', ')), /*#__PURE__*/ react_1.default.createElement(BookmarkTitle, null, (_bookmark$metadata3 = bookmark.metadata) === null || _bookmark$metadata3 === void 0 ? void 0 : _bookmark$metadata3.title), /*#__PURE__*/ react_1.default.createElement(Description, null, (_bookmark$metadata4 = bookmark.metadata) === null || _bookmark$metadata4 === void 0 ? void 0 : _bookmark$metadata4.description))), /*#__PURE__*/ react_1.default.createElement(Options, Object.assign({
        className: viewType
    }, {
        sample: sample
    }), /*#__PURE__*/ react_1.default.createElement(Item, {
        onClick: function onClick() {
            return removeBookmark(bookmark.id);
        },
        leftMargin: true
    }, /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        color: _theme_1.palette.ink,
        hoverColor: _theme_1.palette.vermillion
    }, "Close")), /*#__PURE__*/ react_1.default.createElement(Item, null, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        target: "_blank",
        rel: "noopener",
        href: "https://www.facebook.com/sharer/sharer.php?u=" + bookmark.link
    }, /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        color: _theme_1.palette.ink,
        hoverColor: _theme_1.palette.facebook
    }, "Facebook"))), /*#__PURE__*/ react_1.default.createElement(Item, null, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        target: "_blank",
        rel: "noopener",
        href: "https://twitter.com/share?url=" + bookmark.link
    }, /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        color: _theme_1.palette.ink,
        hoverColor: _theme_1.palette.twitter
    }, "Twitter"))), /*#__PURE__*/ react_1.default.createElement(Item, null, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        target: "_blank",
        rel: "noopener",
        href: "http://pinterest.com/pin/create/button?url=" + bookmark.link + "&media=" + bookmark.imageUrl + "&description=" + ((_bookmark$metadata5 = bookmark.metadata) === null || _bookmark$metadata5 === void 0 ? void 0 : _bookmark$metadata5.title)
    }, /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        color: _theme_1.palette.ink,
        hoverColor: _theme_1.palette.pinterest
    }, "Pinterest"))), /*#__PURE__*/ react_1.default.createElement(Item, null, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        target: "_blank",
        rel: "noopener",
        href: "mailto:?Subject=" + encodeURIComponent((_bookmark$metadata6 = bookmark.metadata) === null || _bookmark$metadata6 === void 0 ? void 0 : _bookmark$metadata6.title) + "&Body=" + bookmark.link
    }, /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        color: _theme_1.palette.ink,
        hoverColor: _theme_1.palette.email
    }, "Email"))))));
}; // Styling
var Item = styled_components_1.default.li.withConfig({
    displayName: "BookmarkCell__Item",
    componentId: "xvnsrb-0"
})(["display:flex;justify-content:center;align-items:center;", " cursor:pointer;& > a,& > div{display:block;width:24px;height:24px;transform:scale3d(1,1,1);transition:background-color 0.25s ease-in-out,transform 0.25s ease-in-out;", "{&:hover{transform:scale3d(1.1,1.1,1);}}}"], function (props) {
    return props.leftMargin && "margin-left: 10px;";
}, _utils_1.mediaQuery('tablet'));
var Alignment = styled_components_1.default.a.withConfig({
    displayName: "BookmarkCell__Alignment",
    componentId: "xvnsrb-1"
})(["z-index:1;display:flex;flex-direction:column;justify-content:space-between;height:100%;"]);
var Content = styled_components_1.default.div.withConfig({
    displayName: "BookmarkCell__Content",
    componentId: "xvnsrb-2"
})(["height:100%;"]);
var Caption = styled_components_1.default.div.withConfig({
    displayName: "BookmarkCell__Caption",
    componentId: "xvnsrb-3"
})(["position:relative;padding-top:32px;"]);
var Options = styled_components_1.default.ul.withConfig({
    displayName: "BookmarkCell__Options",
    componentId: "xvnsrb-4"
})(["z-index:2;display:flex;flex-direction:row;&.moodboard{position:absolute;top:8px;right:8px;padding:8px 16px;background:", ";box-shadow:0px 16px 32px ", ";border-radius:3px;opacity:0;pointer-events:none;transition:opacity 0.3s ease-in-out;}& li{position:relative;margin-right:16px;&:first-of-type{", " padding-right:24px;border-right:1px solid ", ";margin-right:24px;}&:last-of-type{margin-right:0;}}", "{&.moodboard{top:16px;right:16px;}}"], _theme_1.palette.snow, _utils_1.rgba(_theme_1.palette.ink, 0.16), function (props) {
    return props.sample && "display: none;";
}, _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('tablet'));
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "BookmarkCell__Wrapper",
    componentId: "xvnsrb-5"
})(["display:block;position:relative;@media (max-width:767px){&.moodboard:nth-of-type(3n+1){grid-area:span 2 / span 2;}}", "{&.moodboard:nth-of-type(6n+1){grid-area:span 2 / span 2;}&.moodboard:nth-of-type(6n+5){grid-area:span 2 / span 2;}}&.moodboard > div{width:100%;height:100%;}&.moodboard ", "{display:none;}&.moodboard&:hover ", "{opacity:1;pointer-events:all;}"], _utils_1.mediaQuery('tablet'), Caption, Options);
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "BookmarkCell__ImageWrapper",
    componentId: "xvnsrb-6"
})(["display:block;width:100%;height:60vw;overflow:hidden;&.moodboard{height:100% !important;}", "{height:200px;}", "{height:160px;}", "{height:180px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledImage = styled_components_1.default(atoms_1.Image).withConfig({
    displayName: "BookmarkCell__StyledImage",
    componentId: "xvnsrb-7"
})(["", "{transform:scale3d(1,1,1);transition:transform 1.2s ease-in-out;", ":hover &{transform:scale3d(1.08,1.08,1);}}"], _utils_1.mediaQuery('tablet'), Alignment);
var Tags = styled_components_1.default.div.withConfig({
    displayName: "BookmarkCell__Tags",
    componentId: "xvnsrb-8"
})(["", " &::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.4) * 1em);}&::after{margin-bottom:calc((1 - 1.5) * 1em);}"], _theme_1.type.labelSmall);
var BookmarkTitle = styled_components_1.default.h3.withConfig({
    displayName: "BookmarkCell__BookmarkTitle",
    componentId: "xvnsrb-9"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;padding-top:16px;overflow:hidden;text-overflow:ellipsis;", " color:", ";&::before,&::after{display:block;height:0;width:0;margin-top:calc((1 - 1.2) * 1em);content:'';}&::after{margin-top:calc((1 - 1) * 1em);}", "{transition:color 0.25s ease-in-out;", ":hover &{color:", ";}}", "{padding-top:24px;}"], _theme_1.type.h3, _theme_1.palette.black, _utils_1.mediaQuery('tablet'), Alignment, _theme_1.palette.brown, _utils_1.mediaQuery('desktop'));
var Description = styled_components_1.default.p.withConfig({
    displayName: "BookmarkCell__Description",
    componentId: "xvnsrb-10"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;padding-top:16px;margin-top:-8px;margin-bottom:24px;overflow:hidden;text-overflow:ellipsis;", " &::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-bottom:calc((1 - 1.05) * 1em);}", "{padding-top:24px;margin-bottom:32px;transform:translate3d(0,0,0);transition:transform 0.8s ease-in-out;", ":hover &{transform:translate3d(0,-4px,0);}}", "{padding-top:32px;margin-bottom:40px;}"], _theme_1.type.pSmall, _utils_1.mediaQuery('tablet'), Alignment, _utils_1.mediaQuery('desktop'));
var SocialLink = styled_components_1.default.a.withConfig({
    displayName: "BookmarkCell__SocialLink",
    componentId: "xvnsrb-11"
})([""]);
var StyledIcon = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Icon, props);
}).withConfig({
    displayName: "BookmarkCell__StyledIcon",
    componentId: "xvnsrb-12"
})(["transition:background-color 0.25s ease-in-out;", "{", ":hover &{background-color:", ";}}"], _utils_1.mediaQuery('tablet'), Item, function (props) {
    return props.hoverColor;
}); // Typing
exports.default = BookmarkCell;
